import { Injectable } from '@angular/core';

import { Barber } from '../models/barber';

import { DB } from './db';
import { UserService } from './user-service';
import { Util } from './util';
import { BarberService } from './barber-service';

@Injectable({ providedIn: 'root' })
export class FavoriteBarberService {

  constructor(private userService: UserService){
  }

  isFavorited(barberID: string) {

    let favoriteBarberIDs = this.favoriteBarberIDs();
    return Util.contains(favoriteBarberIDs, barberID);
  }

  favoriteBarberIDs(): string[] {
    return this.userService.user.favoriteBarberIDs;
  }



  // Updating favorite barbers

  favoriteBarber(barberID: string, 
    successCallback: () => void, 
    errorCallback: (msg: string) => void) {

    if (this.isFavorited(barberID)) {
      successCallback();
      return;
    }

    var favoriteBarberIDs = this.favoriteBarberIDs();
    favoriteBarberIDs.push(barberID);

    this.userService.update({
      favoriteBarbers: favoriteBarberIDs
    }, successCallback, errorCallback);
  }

  unfavoriteBarber(barberID: string,
    successCallback: () => void, 
    errorCallback: (msg: string) => void) {

    if (!this.isFavorited(barberID)) {
      successCallback();
      return;
    }

    var favoriteBarberIDs = this.favoriteBarberIDs();
    Util.removeItem(favoriteBarberIDs, barberID);

    this.userService.update({
      favoriteBarbers: favoriteBarberIDs
    }, successCallback, errorCallback);
  }



  // Pulling favorite barbers

  getFavoritedBarbers(
    successCallback: (barbers: Barber[]) => void, 
    errorCallback: (msg: string) => void) {

    let favoriteBarberIDs = this.favoriteBarberIDs();
    
    BarberService.pullBarbers(favoriteBarberIDs, (barbers: Barber[]) => {
      successCallback(barbers)
    }, (errorMsg: string) => { errorCallback(errorMsg) })

  }

}
